// src/pages/ResetPassword.js

import React, { useState } from 'react';
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Auth.css';
import { FaGlobe, FaFacebookF, FaWhatsapp, FaInstagram, FaPinterestP } from 'react-icons/fa';

function ResetPassword() {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault(); // Previene il refresh della pagina
    try {
      await sendPasswordResetEmail(auth, email);
      alert('Email di reset inviata! Controlla la tua casella di posta.');
      navigate('/login');
    } catch (error) {
      console.error('Errore durante il reset della password:', error);
      let errorMessage = 'Errore durante il reset della password. Per favore, riprova.';
      if (error.code === 'auth/invalid-email') {
        errorMessage = 'Email non valida.';
      } else if (error.code === 'auth/user-not-found') {
        errorMessage = 'Utente non trovato.';
      }
      alert(errorMessage);
    }
  };

  return (
    <div className="auth-container">
      {/* Header con Logo */}
      <header className="auth-header">
        <img src="/images/tuoLogo.png" alt="Logo" className="auth-logo" />
      </header>
      
      {/* Main Content */}
      <main className="auth-main">
        <h2 className="auth-title">Reset Password</h2>
        <form onSubmit={handleResetPassword} className="auth-form">
          <input
            className="input"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button className="button" type="submit">
            Invia Email di Reset
          </button>
        </form>
        <div className="auth-links">
          <Link to="/login" className="auth-link">Torna al Login</Link>
          <Link to="/signup" className="auth-link">Registrati</Link>
          <Link to="/" className="auth-link">Torna a Benvenuto</Link>
        </div>
      </main>
      
      {/* Footer */}
      <footer className="auth-footer">
        <div className="social-buttons">
          <a href="https://www.tuosito.com" target="_blank" rel="noopener noreferrer" className="social-button" aria-label="Sito Internet">
            <FaGlobe />
          </a>
          <a href="https://www.facebook.com/tuoprofilo" target="_blank" rel="noopener noreferrer" className="social-button" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://wa.me/tuonumber" target="_blank" rel="noopener noreferrer" className="social-button" aria-label="WhatsApp">
            <FaWhatsapp />
          </a>
          <a href="https://www.instagram.com/tuoprofilo" target="_blank" rel="noopener noreferrer" className="social-button" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.pinterest.com/tuoprofilo" target="_blank" rel="noopener noreferrer" className="social-button" aria-label="Pinterest">
            <FaPinterestP />
          </a>
        </div>
        <p className="footer-text">&copy; {new Date().getFullYear()} Parrocchia del S.S. Redentore - Monserrato</p>
      </footer>
    </div>
  );
}

export default ResetPassword;
